import { PublisherTabs } from './publisher-tabs';

export { PublisherTabs };
